module.exports = __webpack_public_path__ + "media/images/icons/twotone/pause-circle-e087191c41b94fb5a1f8d069ff31f016.svg";